/**
 * 상품 목록 정렬 — BO 정렬 상태("컬럼,방향")를 BE `sort`(ProductSortOption) 값으로 바꾼다.
 *
 * BE admin 목록은 Pageable 정렬이 아니라 화이트리스트 enum 으로만 정렬한다(ProductRepositoryImpl
 * .toOrderSpecifier). 등록일(LATEST/OLDEST)·판매가(PRICE_DESC/PRICE_ASC)만 대응이 있어 BO 도 이 두 열만
 * 정렬 가능하게 둔다(ProductTable.SORTABLE_COLUMNS). 대응이 없으면 보내지 않아 BE 기본(LATEST)을 쓴다.
 */
export type ProductSortOption = 'LATEST' | 'OLDEST' | 'PRICE_ASC' | 'PRICE_DESC';

const SORT_OPTION: Record<string, ProductSortOption> = {
  'createdAt,DESC': 'LATEST',
  'createdAt,ASC': 'OLDEST',
  'salePrice,DESC': 'PRICE_DESC',
  'salePrice,ASC': 'PRICE_ASC',
};

export const toProductSortOption = (sort: string | null | undefined): ProductSortOption | undefined =>
  sort ? SORT_OPTION[sort] : undefined;
